<template>

  <div id="app" class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar>
        <md-button class="md-icon-button" @click="menuVisible = !menuVisible" v-show="logged">
          <md-icon>menu</md-icon>
        </md-button>
        <span class="md-title"><img src="/src/assets/logo.jpeg"></span>
      </md-app-toolbar>
      <md-app-drawer :md-active.sync="menuVisible">
        <md-toolbar class="md-transparent" md-elevation="0">Menu</md-toolbar>

        <md-list @click="menuVisible = false">
          <md-list-item to="/carico" class="selected">
            <md-icon>upload</md-icon>
            <span class="md-list-item-text">Carico</span>
          </md-list-item>

          <md-list-item to="/scarico">
            <md-icon>download</md-icon>
            <span class="md-list-item-text">Scarico</span>
          </md-list-item>

          <md-list-item to="/magazzini">
            <md-icon>inventory</md-icon>
            <span class="md-list-item-text">Magazzini</span>
          </md-list-item>

          <md-list-item @click="logout">
            <md-icon>logout</md-icon>
            <span class="md-list-item-text">Esci</span>
          </md-list-item>
        </md-list>
      </md-app-drawer>
      <md-app-content class="md-layout md-alignment-center-center">
        <router-view @loggedIn="loggedIn" />
      </md-app-content>
    </md-app>
  </div>

</template>

<script>

export default {
  name: 'App',
  data: () => ({
    logged: false,
    menuVisible: false
  }),
  mounted () {
    this.$material.selectLocale('it')
    // Ripristino da localStorage perche' se ricarichi la pagina rimette this.logged al volore di default
    if (localStorage.getItem('logged') !== null) {
      this.logged = localStorage.getItem('logged')
    }
  },
  methods: {
    logout () {
      this.logged = false
      localStorage.removeItem('user')
      localStorage.removeItem('logged')
      this.$cookie.delete('token')
      this.$http.get('/auth/logout', { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }).then(response => {
        this.$router.push('/login')
      })
    },
    loggedIn () {
      this.logged = true
      localStorage.setItem('logged', true)
      this.$router.push('/carico')
    },
    async get (url) {
      const resp = await this.$http.get(url, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
      return resp.data
    },
    async post (url, data) {
      const resp = await this.$http.post(url, data, {
        headers: { Authorization: 'Bearer ' + this.$cookie.get('token') }
      })
      return resp.data
    }
  }
}

</script>

<style>

  @import './assets/css/style.css';

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
  }
  .md-list-item .selected {
    background-color: #448aff;
  }
  .md-list-item .selected:hover {
    opacity: 0.12;
  }
  md-app {
    max-height: 100vh;
    border: 1px solid rgba(#000, 0.12);
  }
  .md-title img {
    height: 40px !important;
  }

  .md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }
  .md-app-content.md-content {
    min-width: 100%;
  }
  .md-app-content.md-content > * {
    width: 100%;
    height: 100%;
  }
  .md-app-content {
    height: calc(100vh - 74px);
  }
  .md-app-drawer .md-list-item {
    cursor: pointer;
  }
  .md-app-drawer .md-list-item:hover {
    background-color: #eee;
  }
  .md-table-content {
    min-width: 100vh;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue